import React from "react";
import { Card, Box, Typography } from "@mui/material";

export default function SectionCard({ title, subtitle, action, children, sx }) {
  return (
    <Card sx={{ p: 2.5, height: "100%", display: "flex", flexDirection: "column", ...sx }}>
      {(title || action) && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            gap: 1,
          }}
        >
          <Box>
            {title && <Typography variant="h6">{title}</Typography>}
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
      )}
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>{children}</Box>
    </Card>
  );
}
